import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 150ms aligns perfectly with the 'framer-motion' exit transitions 
    // we integrated into your Consultation Modals.
    const timeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // 'auto' prevents the 'smooth' scroll conflict during route transitions
      });
    }, 150); 

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null; // Navigation logic components must return null for React rendering
};

export default ScrollToTop;